import { render, staticRenderFns } from "./bm.vue?vue&type=template&id=ef7ce0ee&scoped=true"
import script from "./bm.vue?vue&type=script&lang=js"
export * from "./bm.vue?vue&type=script&lang=js"
import style0 from "./bm.vue?vue&type=style&index=0&id=ef7ce0ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7ce0ee",
  null
  
)

export default component.exports